import React, { useState } from "react";
import { DataContext } from "../../../helper/HelperOne";
import NavBar from "../../nav_bar/Navbar";
import PriorityList from "./PriorityList";

const Priority = () => {
    const [searchUi, setSearchUi] = useState(false);
    const [searchData, setSearchData] = useState(null);
    return (
        <DataContext.Provider
            value={{ searchUi, setSearchUi, searchData, setSearchData }}
        >
            <NavBar childrenPage={<PriorityList />} menuId={6} />
        </DataContext.Provider>
    )
}

export default Priority